module.exports = __webpack_public_path__ + "static/img/u84.73db1486.png";